import queryString from "query-string"
import { nanoid } from "components/Stacker/components/Common/helpers"
import { filterVariant } from "lib/utils/helpers"
import { getProductDetails } from "components/Stacker/actions/ProductDetailActions"
import SC from "../constants/StackerConstants"

export const updateStackUrl = (id) => (dispatch) => {
  dispatch({
    type: SC.UPDATE_STACK_URL,
    payload: id,
  })
}

export const loadNextPage = () => (dispatch) => {
  dispatch({
    type: SC.PRODUCTS_NEXT_PAGE,
  })
}

export const resetPagination = () => (dispatch) => {
  dispatch({
    type: SC.PAGINATION_RESET,
  })
}

export const updateProducts = (update) => (dispatch) => {
  dispatch({
    type: SC.UPDATE_PRODUCTS,
    payload: update,
  })
}

export const clearProducts = () => (dispatch) => {
  dispatch({
    type: SC.CLEAR_PRODUCTS,
  })
}

export const addProduct = (id, location, navigate) => {
  id = id.replace(/-/, " ")
  const queryObj = queryString.parse(location.search)
  const addedStack = Array.isArray(queryObj.products)
    ? queryObj.products
    : [queryObj.products]
  const tempStack =
    !addedStack.includes(id) && !addedStack.includes(id.replace(/ /, "-"))
      ? [...addedStack, id]
      : [
          ...addedStack.filter((item) => {
            return item.replace(/-/, " ") !== id
          }),
        ]
  const queryParamsString = queryString.stringify(
    { ...queryObj, products: tempStack },
    { encode: true }
  )
  navigate(`${location.pathname}?${queryParamsString}`)
}

export const addPendingStack = (id) => (dispatch) => {
  dispatch({
    type: SC.ADD_PENDING_STACK,
    payload: id,
  })
}

export const setPendingStack = (stack) => (dispatch) => {
  dispatch({
    type: SC.SET_PENDING_STACK,
    payload: stack,
  })
}

export const addAddedStack = (id) => (dispatch) => {
  dispatch({
    type: SC.ADD_ADDED_STACK,
    payload: id,
  })
}

export const setAddedStack = (stack) => (dispatch) => {
  dispatch({
    type: SC.SET_ADDED_STACK,
    payload: stack,
  })
}

export const previewSelection = (status) => (dispatch) => {
  dispatch({
    type: SC.PREVIEW_SELECTION,
    payload: status,
  })
}

export const reviewSelection = (status) => (dispatch) => {
  dispatch({
    type: SC.REVIEW_SELECTION,
    payload: status,
  })
}

export const setLoadStatus = (status) => (dispatch) => {
  dispatch({
    type: SC.SET_LOAD_STATUS,
    payload: status,
  })
}

export const stackerReset = () => (dispatch) => {
  dispatch({
    type: SC.STACKER_RESET,
  })
}

export const setConfig = (config) => (dispatch) => {
  dispatch({
    type: SC.SET_CONFIG,
    payload: config,
  })
}

export const setProductItemLoaded = () => (dispatch) => {
  dispatch({
    type: SC.PRODUCT_ITEM_LOADED,
  })
}

export const setProductListLoadStatus = (status) => (dispatch) => {
  dispatch({
    type: SC.PRODUCT_LIST_LOADED,
    payload: status,
  })
}

export const setRearrangeStatus = (status) => (dispatch) => {
  dispatch({
    type: SC.STACKER_REARRANGE,
    payload: status,
  })
}

export const setStackerLoadStatus = (status) => (dispatch) => {
  dispatch({
    type: SC.STACKER_LOADED,
    payload: status,
  })
}

export const setStackerReadyStatus = (status) => (dispatch) => {
  dispatch({
    type: SC.SET_STACKER_READY,
    payload: status,
  })
}

export const productListExpanded = (expanded) => (dispatch) => {
  dispatch({
    type: SC.PRODUCT_LIST_EXPANDED,
    payload: expanded,
  })
}

export const showProductInfoPanel = (productInfo) => (dispatch) => {
  dispatch({
    type: SC.SHOW_PRODUCT_INFO,
    payload: productInfo,
  })
}

export const setFilterOpenStatus = (status) => (dispatch) => {
  dispatch({
    type: SC.SET_FILTER_OPEN,
    payload: status,
  })
}
// Refiner actions
export const addRefiner = (data) => (dispatch) => {
  dispatch({
    type: SC.REFINER_ADD,
    payload: data,
  })
}

export const populateRefiners = (args) => (dispatch, getState) => {
  const { chainVariantCode, data } = args
  const { pdp } = getState()

  const buildRefiner = (varProdCode) => {
    const baseProdCode = varProdCode.substr(0, 9)
    const baseProd = pdp[baseProdCode]
    const {
      data: {
        products: { variantOptions },
      },
    } = baseProd
    const selInfo = filterVariant({
      variantOptions,
      selectedVariantCode: varProdCode,
      retailerProducts: data.addedRetailerProducts,
    })
    const R = {}
    const refinerId = nanoid()
    const selectedSize = selInfo.selectedVariant.variantOptions[0]
    R[refinerId] = {
      pid: varProdCode,
      selectedSize,
      ...selInfo,
    }

    dispatch({
      type: SC.REFINER_MAP,
      payload: refinerId,
    })
    dispatch({
      type: SC.REFINER_ADD,
      payload: R,
    })
  }

  if (chainVariantCode) {
    buildRefiner(chainVariantCode)
  }

  data.addedStack.forEach((el) => {
    const varProdCode = el.replace("-", " ")
    buildRefiner(varProdCode)
  })
}

export const refineMetal =
  ({ data, retailerId }) =>
  (dispatch, getState) => {
    const { refinerId, variantCode } = data
    const { pdp } = getState()

    const setMetal = (varCode) => {
      const { pdp: newPdp } = getState()
      const varProd = newPdp[varCode]
      const metalInfo = {
        pid: varCode,
        selectedSize: varProd.selectedVariant.variantOptions[0],
        selectedVariant: varProd.selectedVariant,
        selectedVariantIndex: varProd.selectedVariantIndex,
      }
      const R = {}
      R[refinerId] = metalInfo
      dispatch({
        type: SC.REFINER_METAL_CHANGE,
        payload: R,
      })
    }

    const metalCallback = (varData) => {
      setMetal(variantCode)
    }

    if (!pdp[variantCode]) {
      dispatch(
        getProductDetails({
          args: {
            productId: variantCode,
            callback: metalCallback,
          },
          retailerId,
        })
      )
    } else {
      setMetal(variantCode)
    }
  }

export const refineSize = (data) => (dispatch, getState) => {
  const { refinerId, sizeObj: selectedSize } = data
  const {
    stacker: { refiners },
  } = getState()
  const currentRefiner = refiners[refinerId]
  const R = {}

  R[refinerId] = {
    ...currentRefiner,
    selectedSize,
  }
  dispatch({
    type: SC.REFINER_SIZE_CHANGE,
    payload: R,
  })
}

export const refineSwatch =
  ({ data, retailerId }) =>
  (dispatch, getState) => {
    const { refinerId, selInfo, variantCode } = data
    const {
      pdp,
      stacker: { refiners },
    } = getState()
    const currentRefiner = refiners[refinerId]

    if (!pdp[variantCode]) {
      dispatch(
        getProductDetails({
          args: {
            productId: variantCode,
          },
          retailerId,
        })
      )
    }
    const R = {}
    const selectedSize = selInfo.selectedVariant.variantOptions[0]
    R[refinerId] = {
      ...currentRefiner,
      ...selInfo,
      selectedSize,
      pid: variantCode,
    }

    dispatch({
      type: SC.REFINER_SWATCH_CHANGE,
      payload: R,
    })
  }

export const resetRefiners = () => (dispatch) => {
  dispatch({
    type: SC.REFINER_RESET,
  })
}
